import React from 'react';
import { motion } from 'framer-motion';
interface GlowingButtonProps {
  children: ReactNode;
  onClick?: () => void;
  variant?: 'cyan' | 'green';
  className?: string;
  size?: 'lg' | 'xl';
}
export function GlowingButton({
  children,
  onClick,
  variant = 'cyan',
  className = '',
  size = 'lg'
}: GlowingButtonProps) {
  const baseStyles = 'font-bold rounded-full transition-all duration-300 transform hover:scale-105 active:scale-95 text-white relative overflow-hidden';
  const variantStyles = variant === 'cyan' ? 'bg-cyan-500 hover:bg-cyan-400 animate-pulse-glow' : 'bg-green-500 hover:bg-green-400 animate-pulse-green';
  const sizeStyles = size === 'xl' ? 'text-xl md:text-2xl py-4 px-12' : 'text-lg py-3 px-8';
  return <motion.button whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} onClick={onClick} className={`${baseStyles} ${variantStyles} ${sizeStyles} ${className}`} data-id="element-226">
      <span className="relative z-10" data-id="element-227">{children}</span>
      <div className="absolute inset-0 bg-white/20 blur-lg opacity-0 hover:opacity-100 transition-opacity duration-300" data-id="element-228" />
    </motion.button>;
}